<template>
  <div class="xin">
    <div class="switch">
      <el-tabs v-show="user_list" @tab-click="edit_list">
        <!-- 部门列表 -->

        <el-tab-pane label="部门列表">
          <span slot="label">
            {{ $t("logs.depart1") }}
          </span>
          <div class="switch1">
            <!-- 弹出框2-->
            <div class="main">
            <el-button > {{ $t("logs.depart6") }}</el-button></div>
            <!--  表格 -->
            <div class="table ">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList1"
                :row-class-name="tableRowClassName"
                v-loading="loading"
                :cell-class-name="tableCellClassName"
              >
                
                <el-table-column prop="TYPE" :label="$t('logs.depart2')">
                </el-table-column>
                <el-table-column prop="ISDEFAULT" :label="$t('logs.depart3')">
                </el-table-column>
                <el-table-column prop="ACTIVE" :label="$t('logs.depart4')">
                </el-table-column>
                <el-table-column prop="ACTIVE" :label="$t('logs.depart5')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('logs.audit6')">
                  <template slot-scope="scope">
                       <!-- 查看-->

                    <el-button
                      @click="look_depart(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >{{ $t("logs.depart12") }}</el-button
                    >
                    <!-- 编辑审核流程-->

                    <el-button
                      @click="bianji1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >{{ $t("logs.ldap21") }}</el-button
                    >
                    <!-- 删除-->

                    <el-button
                      @click="handleClick1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      class="iddefault"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                  <!-- 快编辑审核策略-->
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>

        <!-- 增加部门 -->

        <el-tab-pane label="增加部门">
          <span slot="label">
            {{ $t("logs.depart11") }}
          </span>
          <div class="switch1">
            <div class="lie">
                    <table>
                        <tbody>
                          
                            <tr>
                                <!-- 企业部门-->

                                <td>{{ $t("logs.depart2") }}:</td>
                                <td>
                                    <el-input v-model="depart_company" placeholder clearable style="margin-bottom:0"></el-input>

                                    <el-alert :title="$t('logs.autu1_a3')" type="warning" show-icon :closable="false"></el-alert>
                                </td>
                            </tr>
                           
                           
                            <tr>
                                <!-- 上级部门-->

                                <td>{{ $t("logs.depart7") }}:</td>
                                <td>
                                    <el-select v-model="p_depart_id" placeholder class="selece1">
                                        <el-option v-for="item in p_depart_id_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </td>
                            </tr>
                           <tr>
                                <!-- 描述-->

                                <td>{{ $t("logs.policy8") }}:</td>
                                <td>
                                    <el-input v-model="description" placeholder  clearable></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="save_add_depart">{{$t('logs.save_a')}}</el-button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
          </div>
        </el-tab-pane>
      </el-tabs>
        <!-- 编辑部门列表 -->
      <el-tabs v-show="edit_user">
        <!-- 编辑管理员 -->
        <el-tab-pane label="">
          <span slot="label">
            {{ $t("logs.notice8") }}
          </span>
          <div class="switch1">
            <div class="lie">
              <table>
               <tbody>
                          <!-- 企业部门-->
                            <tr>
                                

                                <td>{{ $t("logs.depart2") }}:</td>
                                <td>
                                    <el-input v-model="depart_company" placeholder clearable style="margin-bottom:0"></el-input>

                                    <el-alert :title="$t('logs.autu1_a3')" type="warning" show-icon :closable="false"></el-alert>
                                </td>
                            </tr>
                            <!-- 部门编号-->
                            <tr>
                                

                                <td>{{ $t("logs.depart5") }}:</td>
                                <td>
                                    <el-input v-model="depart_company" placeholder clearable style="margin-bottom:0"></el-input>

                                    <el-alert :title="$t('logs.autu1_a3')" type="warning" show-icon :closable="false"></el-alert>
                                </td>
                            </tr>
                           
                            <tr>
                                <!-- 上级部门-->

                                <td>{{ $t("logs.depart7") }}:</td>
                                <td>
                                    <el-select v-model="p_depart_id" placeholder class="selece1">
                                        <el-option v-for="item in p_depart_id_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </td>
                            </tr>
                           <tr>
                                <!-- 描述-->

                                <td>{{ $t("logs.policy8") }}:</td>
                                <td>
                                    <el-input v-model="description" placeholder  clearable></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="save_edit_depart">{{$t('logs.save_a')}}</el-button>
 <el-button type="danger" @click="cancel_add_depart">{{$t('logs.save_b')}}</el-button>
                                </td>
                            </tr>
                        </tbody>
              </table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
       <!-- 查看部门列表 -->
      <el-tabs v-show="look_depart_show">
        <!--  -->
        <el-tab-pane label="">
          <span slot="label">
            {{ $t("logs.depart13") }}
          </span>
          <div class="switch1">
              <div class="table  table_fenye">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_look"
                :row-class-name="tableRowClassName"
                v-loading="loading"
                :cell-class-name="tableCellClassName"
              >
                
                <el-table-column prop="TYPE" :label="$t('logs.depart2')">
                </el-table-column>
                <el-table-column prop="ISDEFAULT" :label="$t('logs.autu5_a2')"  width="360">
                </el-table-column>
                <el-table-column prop="ACTIVE" :label="$t('logs.depart8')">
                </el-table-column>
                <el-table-column prop="ACTIVE" :label="$t('logs.depart9')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('logs.depart10')">
                 
                  
                </el-table-column>
                 <el-table-column prop="address" :label="$t('logs.Policy_list9')">
                 
                  
                </el-table-column>
              </el-table>

            </div>
              <!--  分页 -->
        <div class="fenye" >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalnums"
          ></el-pagination>
           <el-button type="primary" @click="return_list" class="fenye_button">{{
                        $t("logs.Policy_back")
                      }}</el-button>
          
        </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 查询框 -->

    <!--  底部 -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      description:'',
      p_depart_id:'',
      p_depart_id_arr:'',
      depart_company:'',
         // 总数
      totalnums: 0,
      size: 0,
      // 每页条数
      pagesize: 0,
      //   默认前往第几页
      page: 1,
        fileList_look:[],
        look_depart_show:false,
      notice_subject: "",
      notice_body: "",
      allow_ip: "",
      passwd2: "",
      passwd1: "",
      relation_email: "",
      admin: "",
      edit_user: false,
      user_list: true,
      xian: false,
      btnText: "展示更多",
      checked: "",
      form: {
        username: "",
      },
      value: "",

      tanchu: false,
      options: [
        {
          value: "选项1",
          label: "按天统计",
        },
        {
          value: "选项2",
          label: "按周统计",
        },
        {
          value: "选项3",
          label: "按月统计",
        },
        {
          value: "选项4",
          label: "按年统计",
        },
      ],

      emali: "",
      fileList1: [],
      loading: false,
      ADD_ON: "",
      multi_address_hint: "",
      pwd_hint: "",
    };
  },
  mounted() {
    this.getFileList1();
  },
  methods: {
       // 每页显示多少条 -- 切换
    handleSizeChange(val) {
      this.col = this.col_search;
      console.log(this.col, "给后台返回数据1");
      this.col.pagesize = val;

      

      this.getFileList1();
    },
    // 当前第几页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.col = this.col_search;
      console.log(this.col, "给后台返回数据1");
      this.col.page = val;
     

      this.getFileList1();
    },
    // 判断状态变色
    tableCellClassName({ row }) {
      // console.log(row);

      if (row.ISDEFAULT == "是") {
        return "sent1";
      }
      return "";
    },
    edit_list(a) {
      // console.log(a.index)
      if (a.index == 1) {
        this.admin = "";
      }
    },
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },
    // 数据统计加载
    getFileList1() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/admin.cgi", {
          params: {
            __mode: "list_admin",
            sid: sid,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
            // this.getFileList1();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList1 = res.data.ret.datalist;
            this.ADD_ON = res.data.ret.ADD_ON;
            this.pwd_hint = res.data.ret.pwd_hint;
            this.multi_address_hint = res.data.ret.multi_address_hint;
            // console.log(this.ISSUPER)
          }
        });
    },
    // 编辑管理员保存
    save_user() {
      // this.user_list = false
      // this.edit_user = true
      // this.loading = true;
      // this.tanchu = false
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_admin",
        sid: sid,

        allow_ip: this.allow_ip,
        passwd2: this.passwd2,
        passwd1: this.passwd1,
        relation_email: this.relation_email,
        newadd: 1,
        admin: this.admin,
      });
      this.$axios
        .post(
          "/api/adm/cgi/admin.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.getFileList1();
            this.passwd2 = "";
            this.passwd1 = "";
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    // 新增管理员保存
    tanSend_user_list() {
      // this.loading = true;
      // this.tanchu = false
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_admin",
        sid: sid,

        relation_email: this.relation_email,
        passwd1: this.passwd1,
        passwd2: this.passwd2,
        allow_ip: this.allow_ip,
        admin: this.admin,
        newadd: 0,

        // data_loadok: this.data_loadok_smtp
      });
      this.$axios
        .post(
          "/api/adm/cgi/admin.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.user_list = true;
            this.edit_user = false;
            this.loading = false;
            // this.getFileList1();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
            //   this.$router.push({
            //     name: "login",
            // });
          }
        });
    },
    cancel_add_depart(){
       (this.edit_user = false);
            this.user_list = true;
    },
    
     // 编辑部门保存
        save_edit_depart() {

            // this.loading = true;
            // this.tanchu = false
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_smtp_auth",
                sid: sid,
                ntlm_half: this.ntlm_half == true ? 1 : 0,
                bysmtp: this.bysmtp == true ? 1 : 0,
                smtp_host: this.smtp_host,
                smtp_port: this.smtp_port,
                smtp_helo_host: this.smtp_helo_host,
                smtp_mech: this.smtp_mech,

                data_loadok: this.data_loadok_smtp

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList1();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
               

        },
     // 新增部门保存
        save_add_depart() {

            // this.loading = true;
            // this.tanchu = false
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_smtp_auth",
                sid: sid,
                ntlm_half: this.ntlm_half == true ? 1 : 0,
                bysmtp: this.bysmtp == true ? 1 : 0,
                smtp_host: this.smtp_host,
                smtp_port: this.smtp_port,
                smtp_helo_host: this.smtp_helo_host,
                smtp_mech: this.smtp_mech,

                data_loadok: this.data_loadok_smtp

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList1();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
               

        },
    // 返回部门列表
    return_list(){
      (this.look_depart_show = false);
            this.user_list = true;
    },
     // 查看部门列表
    look_depart(index, scope) {
      // console.log(index, scope);
      // this.admin = scope.USERNAME
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let admin = scope.USERNAME;
      let salt_minion_ip = this.salt_minion_ip1;

      this.$axios
        .get("/api/adm/cgi/admin.cgi", {
          params: {
            __mode: "edit_admin",
            sid: sid,
            admin: admin,
            salt_minion_ip: salt_minion_ip,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            (this.passwd1 = ""), (this.passwd2 = ""), (this.look_depart_show = true);
            this.user_list = false;
            this.loading = false;
          this.fileList_look=res.data.ret.datalist
            // this.getFileList();
          }
        });
    },
    // 编辑部门列表
    bianji1(index, scope) {
      // console.log(index, scope);
      // this.admin = scope.USERNAME
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let admin = scope.USERNAME;
      let salt_minion_ip = this.salt_minion_ip1;

      this.$axios
        .get("/api/adm/cgi/admin.cgi", {
          params: {
            __mode: "edit_admin",
            sid: sid,
            admin: admin,
            salt_minion_ip: salt_minion_ip,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            (this.passwd1 = ""), (this.passwd2 = ""), (this.edit_user = true);
            this.user_list = false;
            this.loading = false;
            this.admin = res.data.ret.ADMIN;
            this.allow_ip = res.data.ret.ALLOW_IP;
            this.relation_email = res.data.ret.RELATION_EMAIL;
            // this.getFileList();
          }
        });
    },
    // 删除1
    handleClick1(index, scope) {
      // console.log(index, scope);
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let abuse_email = scope.ABUSE_EMAIL;
          let salt_minion_ip = this.salt_minion_ip1;

          this.$axios
            .get("/api/adm/cgi/mon.cgi", {
              params: {
                __mode: "del_abuse_email",
                sid: sid,
                abuse_email: abuse_email,
                salt_minion_ip: salt_minion_ip,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList1();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 打开关闭
    tanSend: function() {
      this.tanchu = false;
      this.tanchu1 = false;
    },
    tan4: function() {
      this.tanchu = true;
      //   this.tanchu1 = false;
    },
    tanOff: function() {
      this.tanchu = false;
      //   this.tanchu1 = false;
    },
    off_user: function() {
      this.user_list = true;
      this.edit_user = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/fengye.less";
/deep/ .table .el-table {
  height: calc(100vh - 180px);
}
/deep/ .table_fenye .el-table {
  height: calc(100vh - 225px);
}
/deep/ .fenye_button{
  padding: 8px 10px;
  margin-left: 20px;
}
</style>
